/**
 * Created by Owner on 2016/10/24.
 * 定位胆
 */
import {Component} from '@angular/core';
import {LotteryMathZXFSComponent} from "./zxfs";
import {LotteryMath} from "./lotteryMath";

@Component({
  selector: 'lottery-math-dwd',
  templateUrl: 'selectMath.html',
})
export class LotteryMathDWDComponent extends LotteryMathZXFSComponent implements LotteryMath {

  changeTotal() {
    let mname = this.selectAreaOption["mname"];
    let tmpTotal: number = 0;
    let data_sel = this.children.toArray();
    for (let j = 0; j < this.selectAreaOption["layout"].length; j++) {
      tmpTotal += data_sel[j]["selectNo"].length;
    }
    this.setTotal(tmpTotal);
  }
}



// WEBPACK FOOTER //
// ./src/component/+lotteryMath/dwd.ts